"use client";
import React, { useState } from "react";
import CUSTOMERS from "@/components/Customers"
import DRIVE from "@/components/Drivers";
import BUSINESSES from "./Businesses";

export default function Wwd() {
  const [clicked, setClicked] = useState("Customers");
  
  return (
    <div className=" py-10 max-w-[1040px] mx-auto px-5 md:px-5 lg:px-5" id="ourservices">
      <div className="flex flex-col md:flex-row justify-between items-center pb-5">
        <div>
          <h1 className="text-black sb-ac text-[50px]">What We Do</h1>
          <p className="text-[#8A8C8F]">
            From local deliveries to last-mile solutions,we've got you covered
          </p>
        </div>
        <div className="max-w-[323px]">
          <div className="flex flex-row justify-between items-center">
            <div className="cursor-pointer" onClick={() => {
                setClicked("Customers")
            }}>
              {clicked === "Customers" ? (
                <img src="/assets/customers-a.svg" />
              ) : (
                <img src="/assets/customer.svg" />
              )}
               <p className="text-[12px] sb-ac text-center" style={{ color : clicked === "Customers" ? "#000000": "#dddddd"}}>Customers</p>
            </div>
            <div>
              <img src="/assets/dott.svg" />
            </div>
            <div className="cursor-pointer" onClick={() => {
                setClicked("drive")
            }}>
              {clicked === "drive" ? (
                <img src="/assets/drive-a.svg" />
              ) : (
                <img src="/assets/drive.svg" />
              )}
               <p className="text-[12px] sb-ac text-center" style={{ color : clicked === "drive" ? "#000000": "#dddddd"}}>Drivers</p>
            </div>
            <div>
              <img src="/assets/dott.svg" />
            </div>
            <div className="cursor-pointer" onClick={() => {
                setClicked("businesses")
            }}>
              {clicked === "businesses" ? (
                <img src="/assets/businesses-a.svg" />
              ) : (
                <img src="/assets/businesses.svg" />
              )}
               <p className="text-[12px] sb-ac text-center" style={{ color : clicked === "businesses" ? "#000000": "#dddddd"}}>Businesses</p>
            </div>
          </div>
        </div>
      </div>

      <div>
             { clicked === "Customers" &&   <CUSTOMERS/>}
             { clicked === "drive" &&   <DRIVE/>}
             { clicked === "businesses" &&   <BUSINESSES/>}
             
           
      </div>
    </div>
  );
}
